function r(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? o(t.position) : "start" in t || "end" in t ? o(t) : "line" in t || "column" in t ? i(t) : "";
}
function i(t) {
  return e(t && t.line) + ":" + e(t && t.column);
}
function o(t) {
  return i(t && t.start) + "-" + i(t && t.end);
}
function e(t) {
  return t && typeof t == "number" ? t : 1;
}
function u() {
}
export {
  u as o,
  r as s
};
